
    import {defineComponent, reactive} from 'vue'
    import {useRoute} from "vue-router";

    interface State {
        channelType: string; // 家选 承诺100天
        reportLevel: number;
    }
    export default defineComponent({
        name: "reminderText",
        setup() {
            let state: State = reactive({
                channelType: '',
                reportLevel: 0
            })
            
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            return {
                state
            }
        },
    })
